// extracted by mini-css-extract-plugin
module.exports = {"light":"title_light__KbqTJ"};